(function () {
  //Get all the collapsible-content sections.
  const elements = document.getElementsByClassName('collapsible-content');

  //Get the ul element that is inside the collapsible-content-links-container section.
  let links = document.getElementById('collapsible-content-links');

  for (let i = 0; i < elements.length; i++) {
    //Get the section element of the collapsible-content to get the section ID.
    const sectionElement = elements[i].closest('section');
    //Get the h2 element to get the collapsible-content__heading text.
    const h2Text = elements[i].querySelector('h2').innerText;

    //Create an anchor and add the collapsible-content__heading text and section information.
    let anchorLink = '#' + sectionElement.id;
    let anchor = document.createElement('a');
    anchor.href = anchorLink;
    anchor.innerText = h2Text;
    anchor.onclick = function () {
      addIsActiveClass(this);
    };

    //Add the is-active class to the anchor if the id is on the url.
    if (window.location.hash) {
      if (anchorLink === window.location.hash) {
        anchor.className = 'is-active';
      }
    }

    //Create a li element to add the anchor information.
    let li = document.createElement('li');
    li.appendChild(anchor);

    //Add the li element to the collapsible-content-links.
    links.appendChild(li);
  }
})();

function addIsActiveClass(anchor) {
  //Get all the anchors inside the ul element.
  const links = document.querySelectorAll('#collapsible-content-links a');
  links.forEach(function (link) {
    //Remove the is-active class from all the anchors.
    link.classList.remove('is-active');
  });

  //Add the is-active class to the anchor clicked.
  anchor.className = 'is-active';
}
